module.exports = __webpack_public_path__ + "img/conteudo-estrela-esquerda.1f568c72.png";